import React from 'react';

const Background = () => {
  return (
    <div style={{
      minHeight: '300vh', // Kéo dài trang ra 3 lần
      background: '#0a0a0a', // Nền đen như ảnh
      position: 'relative',
      overflow: 'hidden'
    }}>
      
      {/* Trading Chart Background */}
     
      {/* Grid Pattern */}
    

      {/* Content Area */}
     

      {/* CSS Animations */}
     
    </div>
  );
};

export default Background;